export default "__VITE_ASSET__6d604810__"